import React from 'react';
import { IProps } from './component';
import { useDrop, useDrag } from 'react-dnd';
import ItemTypes from '../ItemTypes';
import Card from '../Card';
import { useSelector, useDispatch } from 'react-redux';
import { findIdSelector } from '../reduxSelector';
import { useParams } from 'react-router';
import { generateId, generateSectionalIds, setLayoutProperties, mergeAssetFieldWithFormField } from '../../../../../../helpers/commonFunction'
import { PUSH_ACTION_STACK } from '../../../../../../stateManager/store/formCreation/types';
import { addFormJson, addRemoveOnDragComplete, removeComponentFromJson } from '../../../../../../stateManager/store/formCreation/action';
import { addAssetJson } from '../../../../../../stateManager/store/assets/action';
import { getRandomId } from "../../../../../../utils/random-id";
import _ from 'lodash';

export const Container = (props: IProps) => {
    const { json } = props;
    const dispatch = useDispatch();
    const params: any = useParams();
    const { list: assets } = useSelector((state: any) => state.assets);
    const assetEditMode = useSelector((state: any) => state.assets.assetEditMode);
    const selectedAssetId = useSelector((state: any) => state.assets.selectedAssetId);
    const stateCards = useSelector(state => findIdSelector(state, params.formId, props.id.split("#")))
    let cards: any[] = [];
    if (json.isAsset || (assetEditMode && selectedAssetId)) {
        cards = json.fields || [];
    } else {
        cards = stateCards;
    }

    const cardContainer = useSelector(state => {
        const cardIdSplit = props.id.split('#');
        cardIdSplit.pop()
        return findIdSelector(state, params.formId, cardIdSplit, true)
    })

    const [, drag] = useDrag({
        item: { type: ItemTypes.CARD, id: props.id, json: props.json, containerId: cardContainer && cardContainer.id, container: cardContainer },
        end: (draggedItem: any, monitor) => {
            if (monitor.didDrop()) {
                const deleteData: any = {
                    formid: params.formId,
                    draggedItemContainer: JSON.parse(JSON.stringify(cardContainer)),
                    itemId: draggedItem.id
                }

                const undoDeleteData: any = {
                    formid: params.formId,
                    droppedContainer: { json: JSON.parse(JSON.stringify(cardContainer)) },
                    draggedItem: JSON.parse(JSON.stringify(draggedItem))
                }

                const { isDragComplete, addData, undoAddData } = monitor.getDropResult()

                isDragComplete && dispatch({
                    type: PUSH_ACTION_STACK,
                    data: {
                        undo: () => {
                            dispatch(addRemoveOnDragComplete(undoAddData, undoDeleteData, true))
                        },
                        redo: () => {
                            dispatch(addRemoveOnDragComplete(deleteData, addData))
                        }
                    }
                })

                isDragComplete && dispatch(addRemoveOnDragComplete(
                    deleteData,
                    addData
                ))
            }
        }
    })

    const [{ isOver, canDrop }, drop] = useDrop({
        // accept: [ItemTypes.BOX,ItemTypes.CARD,ItemTypes.SECTION],
        accept: [ItemTypes.BOX, ItemTypes.CARD],
        drop: (item: any, monitor) => {
            const itemClone: any = JSON.parse(JSON.stringify(item))
            const elementId: string = getRandomId();
            const componentId = getRandomId();
            if (!monitor.didDrop()) {
                setLayoutProperties(props.json, itemClone.json)
            }

            // Check if dropped-item is an asset
            if (item.type === ItemTypes.BOX && !monitor.didDrop() && item.isAsset) {
                let newItem: any;
                const newId: string = generateId(item, { json: props.json });
                const assetInstanceId = getRandomId()

                if (item.json && item.json.fields && item.json.fields.length > 0) {
                    newItem = generateSectionalIds(item, newId)
                } else {
                    newItem = JSON.parse(JSON.stringify(item.json))
                    newItem.id = newId
                }
                newItem.assetInstanceId = assetInstanceId
                newItem.assetBindPrefix = getRandomId()

                const undoAddData = {
                    formid: params.formId,
                    draggedItemContainer: JSON.parse(JSON.stringify(props.json)),
                    itemId: newId
                }

                const generatedId = newId
                // const elementId = getRandomId();

                dispatch({
                    type: PUSH_ACTION_STACK,
                    data: {
                        undo: () => {
                            dispatch(undoAddData)
                        },
                        redo: () => {
                            dispatch(addFormJson({ formId: params.formId, data: { ...item.json, label: item.label, id: generatedId } }))
                        }
                    }
                })

                dispatch(addFormJson({ formId: params.formId, data: { ...newItem } }))
                // return { isDragComplete: true, addData, undoAddData }
            } else if (itemClone.type === ItemTypes.BOX && !monitor.didDrop()) {
                let propertyJson: any = {};
                let windows: any = window;
                let itemConfig: any;
                if (itemClone.json && itemClone.json?.widgetName) {
                    itemConfig = windows[itemClone.json.type].data.widgets[itemClone.json.widgetName]
                    if (itemConfig.config) {
                        for (let key in itemConfig.config) {
                            if (itemConfig.config[key].section === "properties" || itemConfig.config[key].section === "validate" || itemConfig.config[key].section === "data") {
                                propertyJson = {
                                    ...propertyJson, [key]: {
                                        id: itemClone.id,
                                        [key]: itemConfig.config[key].default
                                    }
                                }
                            }
                            _.merge(itemClone.json.properties, propertyJson[key])
                        }
                    }
                }

                //Generate a new ID for the dropped element
                const idArray = cards.length > 0 ? cards.map((el: any) => {
                    return parseInt(el.id.split('-')[el.id.split('-').length - 1])
                }) : []

                const idIncrement = (idArray.length > 0) ? Math.max(...idArray) + 1 : 0
                const generatedId = props.id + "#" + itemClone.id + "-" + idIncrement

                if (assetEditMode && selectedAssetId) {
                    dispatch(
                        addAssetJson({
                            data: {
                                ...itemClone.json,
                                label: itemClone.label,
                                id: generatedId,
                                elementId,
                                componentId,
                                isAsset: true,
                                assetId: selectedAssetId,
                                editBind: true,
                            },
                        })
                    );
                } else {
                    dispatch({
                        type: PUSH_ACTION_STACK,
                        data: {
                            undo: () => {
                                dispatch(removeComponentFromJson({
                                    formid: params.formId,
                                    draggedItemContainer: JSON.parse(JSON.stringify(props.json)),
                                    itemId: generatedId
                                }))
                            },
                            redo: () => {
                                dispatch(addFormJson({ formId: params.formId, data: { ...itemClone.json, label: itemClone.label, id: generatedId, elementId, componentId } }))
                            }
                        }
                    })
                    dispatch(addFormJson({ formId: params.formId, data: { ...itemClone.json, label: itemClone.label, id: generatedId, elementId, componentId } }))
                }
                // } else if ((item.type === ItemTypes.CARD || item.type === ItemTypes.SECTION) && !monitor.didDrop()) {
            } else if ((itemClone.type === ItemTypes.CARD) && !monitor.didDrop()) {
                let newItem: any = {};
                const componentId = getRandomId();
                newItem.componentId = componentId;

                const newId: string = generateId(itemClone, { json: props.json });

                if (itemClone.json && itemClone.json.fields && itemClone.json.fields.length > 0) {
                    newItem = generateSectionalIds(itemClone, newId)
                } else {
                    newItem = JSON.parse(JSON.stringify(itemClone.json))
                    newItem.id = newId
                }

                const addData = {
                    formid: params.formId,
                    droppedContainer: { json: JSON.parse(JSON.stringify(props.json)) },
                    draggedItem: newItem
                }

                const undoAddData = {
                    formid: params.formId,
                    draggedItemContainer: JSON.parse(JSON.stringify(props.json)),
                    itemId: newId
                }
                return { isDragComplete: true, addData, undoAddData }
            }
        },
        canDrop: (item) => {
            if (props.json && props.json.isGroup) {
                return false
            } else if (props.json && props.json.isAsset && !assetEditMode) {
                return false
            } else if (item.type !== ItemTypes.BOX && item.json.isChildAsset && !assetEditMode) {
                return false
            } else if (assetEditMode && props.json.assetId !== selectedAssetId) {
                return false
            } else if (item.type === ItemTypes.BOX) {
                return true
            } else if (item.type === ItemTypes.SECTION || item.type === ItemTypes.CARD) {
                if (item.id.startsWith(props.id)) {
                    //Prevents drops happening within the same container
                    if ((item.id.split('#').length - props.id.split('#').length) > 1) {
                        return true
                    }
                    return false
                } else if (props.id.startsWith(item.id)) {
                    // Prevents parent section dropping within their own child sections
                    return false
                }
                return true
            }
            return false
        },
        collect: monitor => ({
            isOver: monitor.isOver(),
            isOverCurrent: monitor.isOver({ shallow: true }),
            canDrop: monitor.canDrop(),
        })
    })

    // const findCard = (id: string) => {
    //     const card = (cards).filter((c: any) => `${c.id}` === id.toString())[0]
    //     return {
    //         card,
    //         index: findIndex(cards, card),
    //     }
    // }

    // const moveCard = (
    //     (id: string, atIndex: number) => {
    //         const { card, index } = findCard(id);
    //         if (card) {
    //             let Localcards = (cards);
    //             Localcards.splice(index, 1);
    //             Localcards.splice(atIndex, 0, card)
    //         }

    //     }
    // )

    const layout = props.json.properties.layout
    const theme = props.json.properties.theme
    const isActive = isOver && canDrop;

    const containerStyle: any = layout && {
        // backgroundColor: "cyan",
        // margin: `${layout.marginTop || 0}px ${layout.marginRight || 0}px ${layout.marginBottom || 0}px ${layout.marginLeft || 0}px`,
        // padding: `${layout.paddingTop || 0}px ${layout.paddingRight || 0}px ${layout.paddingBottom || 0}px ${layout.paddingLeft || 0}px`,
        display: "flex",
        flexDirection: layout.direction,
        // height: '100%',
        width: '100%',
        justifyContent: (layout.direction === 'row' ? layout.horizontalChild : layout.verticalChild),
        alignItems: (layout.direction === 'row' ? layout.verticalChild : layout.horizontalChild),
        flexWrap: (layout.direction === 'row' ? 'wrap' : 'nowrap'),
        borderRadius: theme && theme.borderRadius,
        boxShadow: theme && theme.boxShadow,
        border: canDrop ? `3px dashed ${isActive ? "#c5e1a5" : canDrop ? "pink" : "white"}` : (theme && theme.border),
        backgroundColor: theme && theme.background && `rgba(${theme.background.r}, ${theme.background.g}, ${theme.background.b}, ${theme.background.a})`,
        // minWidth: layout.minWidth,
        // maxWidth: layout.maxWidth,
        // overflow: 'auto'
        // alignSelf: ( layout.parent === 'row' ? layout.vertical : layout.horizontal  )
    }

    if (props.json.properties.bgImage) {
        containerStyle.backgroundImage = `url(${props.json.properties.bgImage})`
    }

    const getAssetField = (field: any) => {
        const aId = field.assetId

        if (aId && assets[aId] && assets[aId].json && field.elementId === assets[aId].json.elementId) {
            const assetCopy = JSON.parse(JSON.stringify(assets[aId].json))
            const fieldCopy = JSON.parse(JSON.stringify(field))
            return mergeAssetFieldWithFormField(assetCopy, fieldCopy)
        }

        return field
    }

    return (
        <div ref={(ref) => drag(drop(ref))} style={containerStyle}>
            {cards && cards.map((res: any) => {
                const updatedRes = getAssetField(res)
                return (<Card data-test-id={`card${updatedRes.label}`} key={updatedRes.id} id={updatedRes.id}
                    canEdit={props.canEdit}
                    name={updatedRes.label}
                    JsonData={updatedRes}
                    containerBg={theme && theme.background && `rgba(${theme.background.r}, ${theme.background.g}, ${theme.background.b}, ${theme.background.a})`}
                />)
            })}
            {cards && cards.length === 0 ?
                <div style={{ height: '100px', width: '100px' }}></div>
                :
                null
            }
        </div>
    )
}
